/*--------------------------------------------------------------
# Custom scripts for Timeline Slider block
--------------------------------------------------------------*/

// 3 column default
const timelineSlider = document.querySelectorAll('.timeline-slider .swiper');
const timelineSliderPagination = document.querySelectorAll('.timeline .timeline-swiper-pagination');
const timelineSliderNext = document.querySelectorAll('.timeline .timeline-swiper-next');
const timelineSliderPrev = document.querySelectorAll('.timeline .timeline-swiper-prev');

for( i = 0; i < timelineSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    timelineSlider[i].classList.add('swiper-' + i);
    timelineSliderPagination[i].classList.add('timeline-swiper-pagination-' + i);
    timelineSliderNext[i].classList.add('timeline-swiper-next-' + i);
    timelineSliderPrev[i].classList.add('timeline-swiper-prev-' + i);

    var initTimelineSlider = new Swiper('.timeline-slider .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        loop: false,
        mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
        },
        pagination: {
            el: '.timeline .timeline-swiper-pagination-' + i,
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.timeline .timeline-swiper-next-' + i,
            prevEl: '.timeline .timeline-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            748: {
                slidesPerView: 2.05,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        }
    });
}
